import React from 'react';

// The kiosk configuration form: publication → page → figure selects and the
// save button (state + handlers owned by KioskPage).
export default function KioskConfigForm({
  publications,
  pages,
  figures,
  loadingPublications,
  loadingPages,
  loadingFigures,
  selectedPublicationId,
  selectedPageId,
  selectedFigureId,
  saved,
  onSelectPublication,
  onSelectPage,
  onSelectFigure,
  onSave
}) {
  return (
    <form onSubmit={onSave}>
      <div className="mb-3">
        <label htmlFor="publicationSelect" className="form-label">
          <i className="bi bi-book" /> Select Publication
        </label>
        <select
          id="publicationSelect"
          className="form-select"
          disabled={loadingPublications}
          value={selectedPublicationId ?? ''}
          onChange={(e) => onSelectPublication(e.target.value || null)}
        >
          <option value="">-- Select a publication --</option>
          {publications.map((pub) => (
            <option key={pub.id} value={pub.id}>
              {pub.title || 'Untitled'} - {pub.author}
            </option>
          ))}
        </select>
      </div>

      <div className="mb-3">
        <label htmlFor="pageSelect" className="form-label">
          <i className="bi bi-file-text" /> Select Page
        </label>
        <select
          id="pageSelect"
          className="form-select"
          disabled={loadingPages || selectedPublicationId === null}
          value={selectedPageId ?? ''}
          onChange={(e) => onSelectPage(e.target.value || null)}
        >
          <option value="">-- Select a publication first --</option>
          {pages.map((page) => (
            <option key={page.id} value={page.id}>
              {page.pageNumber + 1}
            </option>
          ))}
        </select>
      </div>

      <div className="mb-3">
        <label htmlFor="figureSelect" className="form-label">
          <i className="bi bi-file-text" /> Select Figure
        </label>
        <select
          id="figureSelect"
          className="form-select"
          disabled={loadingFigures || selectedPageId === null}
          value={selectedFigureId ?? ''}
          onChange={(e) => onSelectFigure(e.target.value || null)}
        >
          <option value="">-- Select a page first --</option>
          {figures.map((figure) => (
            <option key={figure.id} value={figure.id}>
              {figure.id} - {figure.type}
            </option>
          ))}
        </select>
      </div>

      <div className="d-grid gap-2">
        <button type="submit" className="btn btn-primary" disabled={!selectedFigureId}>
          <i className="bi bi-save" /> Save Configuration
        </button>
      </div>
      {saved && <div className="alert alert-success mt-3">Kiosk configuration saved!</div>}
    </form>
  );
}
